/**
 * Watermark Utility Functions
 *
 * Helper functions for determining watermark visibility and configuration
 * based on studio owner's subscription plan.
 */

import type { WatermarkConfig } from '../types/watermark';

/**
 * Determine if watermark should be displayed based on owner's plan.
 *
 * @param ownerPlanSlug - Studio owner's subscription plan slug (e.g., 'free', 'starter', 'growth', 'pro')
 * @returns True if watermark should be displayed (only for 'free' plan)
 */
export const shouldShowWatermark = (ownerPlanSlug?: string | null): boolean =>
  // Show watermark only for free plan
  ownerPlanSlug === 'free';

/**
 * Generate watermark configuration object.
 *
 * @param ownerPlanSlug - Studio owner's subscription plan slug
 * @param textColor - Theme text color to use for the watermark
 * @returns Complete watermark configuration
 */
export const getWatermarkConfig = (
  ownerPlanSlug?: string | null,
  textColor: string = '#1F1F1F'
): WatermarkConfig => ({
  shouldDisplay: shouldShowWatermark(ownerPlanSlug),
  textColor,
  linkUrl: 'https://tools.dance',
  text: 'tools.dance',
});
